import { useHistory, useParams } from "react-router-dom";
import { useState } from "react";
import dayjs from "dayjs";

import { Button, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, Table, TableCell, TableContainer, TableRow, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ChevronRight } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';

import { IListActivitiesProps, IActivity } from "../types";
import { useAuth } from "contexts/auth";

export function ListActivities({ activities: data, workspace }: IListActivitiesProps) {
  const history = useHistory();
  const user = useAuth();
  const isBuyer = ["70204870000168", "70204870000320", "70204870000249", "70204870000249", "70204870000320", "59291534000167", "47756998000112", "31439951000195", "34499567000176", "00278017000105"].includes(user?.user?.organization?.cnpj ?? "");
  //   const { workspaceId } = useParams() as { workspaceId: string };

  const [currentFilters, setCurrentFilters] = useState({
    activityName: "",
    activityType: "TODOS",
    activityLastExecution: null,
  });

  function handleChangeFilters(filters: typeof currentFilters) {
    setCurrentFilters({ ...filters });
  }

  function handleFilters(activities: IActivity[]): IActivity[] {
      return activities.filter(activity => {
          const isActivityNameFiltered = activity?.name?.toLocaleLowerCase()?.includes(currentFilters.activityName) ?? false;
          const isLastExecutionFiltered = !currentFilters?.activityLastExecution ? true : !activity?.status?.lastExecutionAt ? false : (dayjs(activity?.status?.lastExecutionAt).format('DD/MM/YYYY') === dayjs(currentFilters?.activityLastExecution).format('DD/MM/YYYY'));

          return isActivityNameFiltered && isLastExecutionFiltered;
      });  
  }

  const shouldNotRedirect = ["Sincronização com eSocial", "Sincronização API", "Retorno da operadora"];

  const notAllowedRvilCnpjs = ["21488419000104", "37395761000108", "48635379000132", "21817739000160", "02778713000106", "12967567000110", "06301462000206", "93029643000149", "36149648000171", "02640577000274", "31022724000160", "48635379000566", "48635379000647", "02640577000193", "07465163000199", "17481492000187", "03102737000103", "48635379000809", "06301462000125", "23183696000134", "08226363000151", "10742079000180", "07441794000178", "14546997000194", "11875045000126", "03476684000190", "04293736000156"];
  const notAllowedCnpjs = [...notAllowedRvilCnpjs, "00000000000194", "48785828009428", "08769549000157", "08769549000238", "08769549001048", "48785828000129", "35352377000194", "48785828001958", "48785828008456", "48785828008537", "48785828008960", "48785828009266", "48785828009347", "48785828009509", "47786631000141", "75612521000107", "23363535000122", "70204870000168", "70204870000249", "70204870000320", "12066996000117", "13752457000102", "10093633000145", "05239984000181", "30010449000100"];
  const notAllowedActivities = ["Conferir Movimentação", "Exportar Movimentações"];
  const hasNewMovementActivities = data.activitiesProcess.filter(a => (a?.name === "Exportar Movimentação" || a?.name === "Conferir Movimentações"))?.length > 0 ? true : false;

  // if (!(notAllowedCnpjs.includes(user?.user?.organization?.cnpj ?? "") && notAllowedActivities.includes(arguments.name))) false
  // true

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Selecione uma atividade</h1>
      </div>
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <TextField
          fullWidth
          label='Nome da atividade'
          placeholder='Digite para pesquisar'
          variant='outlined'
          value={currentFilters.activityName}
          onChange={(e) => handleChangeFilters({ ...currentFilters, activityName: e.target.value })}
          InputProps={{ 
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon color='action' style={{ width: '24px', aspectRatio: '1' }}/>
              </InputAdornment>
            ),
          }}
        />
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <FormControl style={{ width: '250px' }}>
            <InputLabel id="tipo_atividade">Tipo de atividade</InputLabel>
            <Select
              labelId="tipo_atividade"
              value={currentFilters.activityType}
              onChange={(e) => handleChangeFilters({ ...currentFilters, activityType: e.target.value })}
              style={{ height: '55.3px', marginBottom: '2.7px' }}
            >
              <MenuItem value={'LOAD'}>Preparar Dados</MenuItem>
              <MenuItem value={'EXECUTE'}>Executar processo</MenuItem>
              <MenuItem value={'CHECK'}>Validação</MenuItem>
              <MenuItem value={'SIMULATE'}>Simulação</MenuItem>
              <MenuItem value={'TODOS'}>Todos</MenuItem>
            </Select>
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Última atualização"
              format="DD / MM / YYYY"
              value={currentFilters.activityLastExecution}
              onChange={(e) => handleChangeFilters({ ...currentFilters, activityLastExecution: e })}
              slotProps={{ textField: { style: { maxWidth: '260px' } }}}
            />
          </LocalizationProvider>
          <Button onClick={() => handleChangeFilters({ activityType: 'TODOS', activityName: '', activityLastExecution: null })}>Limpar filtro</Button>
        </div>
      </div>
      {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'LOAD') && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
            <span style={{ fontSize: '13px', fontWeight: '400' }}>Preparar Dados</span> 
          </div>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableRow style={{ height: '70px'}}>
                <TableCell style={{ width: '600px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Nome
                  </span>
                </TableCell>
                <TableCell style={{ width: '1000px', backgroundColor: "red" }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Status
                  </span>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
                {handleFilters(data.activitiesLoad).map(activity => (
                  <TableRow key={activity.id} style={{ height: '70px'}}>
                    <TableCell>{activity.name}</TableCell>
                    <TableCell>
                      <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span>Aguardando</span>
                      </div>
                    </TableCell>
                      <TableCell>
                        {!shouldNotRedirect.includes(activity.name) && (
                          <IconButton size="small" style={{ cursor: 'pointer' }} onClick={() => {
                            if (activity.name === 'Carregar PJs') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/pjs`);
                            if (activity.name === 'Dados faltantes') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/dados-faltantes/${activity.workspaceActivityId}`);                          
                            if (activity.name === 'Carregar posição cadastral') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/posicao-cadastral/${activity.workspaceActivityId}`);                          
                            if (activity.name === 'Governança de dados') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/data-governance`);

                            // if (activity.activityName === 'Implantação') history.push(`/contract/${organizationId}/${contractId}/${activity.activityId}`);
                          }}>
                            <ChevronRight />
                          </IconButton>
                        )}
                      </TableCell>
                  </TableRow>
                ))}
            </Table>
          </TableContainer>
        </div>
      )}
      {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'EXECUTE') && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
            <span style={{ fontSize: '13px', fontWeight: '400' }}>Executar processos</span> 
          </div>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableRow style={{ height: '70px'}}>
                <TableCell style={{ width: '600px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Nome
                  </span>
                </TableCell>
                <TableCell style={{ width: '1000px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Status
                  </span>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
                {handleFilters(data.activitiesProcess).filter(a => !(notAllowedCnpjs.includes(user?.user?.organization?.cnpj ?? "") && notAllowedActivities.includes(a.name) && !!hasNewMovementActivities)).map(activity => (
                  <TableRow key={activity.id} style={{ height: '70px'}}>
                    <TableCell>{activity.name}</TableCell>
                    <TableCell>
                      {activity.status?.status === "IDLE" && (
                        <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                          <span>Aguardando</span>
                        </div>
                      )}
                      {activity.status?.status === "PENDING" && (
                        <div style={{ color: '#EF6C00', backgroundColor: '#EF6C0014', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                          <span>Pendente</span>
                        </div>
                      )}
                      {activity.status?.status === "SUCCESS" && (
                        <div style={{ color: '#2E7D32', backgroundColor: '#2E7D3214', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                          <span>Executado</span>
                        </div>
                      )}
                      {activity.status?.status === "FAILED" && (
                        <div style={{ color: '#a30000', backgroundColor: '#ff7d7d3b', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                          <span>Falhou</span>
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {!shouldNotRedirect.includes(activity.name) && (
                        <IconButton size="small" style={{ cursor: 'pointer' }} onClick={() => {
                          if (activity.name === 'Conferir Movimentação') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/movimentacao`)
                          if (activity.name === 'Exportar Movimentações') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/exportar-movimentacao/${activity.workspaceActivityId}`);
                          if (activity.name === 'QBem API: Carregamento de Arquivo') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/qbem_api_file_upload/${activity.workspaceActivityId}`);
                          if (activity.name === 'QBem API: Movimentação Direta') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/qbem_api_direct/${activity.workspaceActivityId}`);
                          
                          if (activity.name === 'Conferir Movimentações') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/movements-check`)
                          if (activity.name === 'Exportar Movimentação') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/movements-export`);

                          // if (activity.name === 'Conferir Movimentação') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/movements`)
                          // if (activity.name === 'Exportar Movimentações') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/movements?view=export`);
                        }}>
                          <ChevronRight />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </Table>
          </TableContainer>
        </div>
      )}
      {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'CHECK') && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
            <span style={{ fontSize: '13px', fontWeight: '400' }}>Validação</span> 
          </div>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableRow style={{ height: '70px'}}>
                <TableCell style={{ width: '600px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Nome
                  </span>
                </TableCell>
                <TableCell style={{ width: '1000px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Status
                  </span>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
                {handleFilters(data.activitiesValidation).map(activity => (
                  <TableRow key={activity.id} style={{ height: '70px'}}>
                    <TableCell>{activity.name}</TableCell>
                    <TableCell>
                      <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span>Aguardando</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      {!shouldNotRedirect.includes(activity.name) && (
                        <IconButton size="small" style={{ cursor: 'pointer' }} onClick={() => {
                          if (activity.name === 'Bate Cadastral') history.push(`/v2/workspaces/${workspace.id}/templates/${activity.id}/bate-cadastral/${activity.workspaceActivityId}`);
                          // if (activity.activityName === 'Movimentação') history.push(`/contract/movimentacao/${organizationId}/${contractId}/${activity.activityId}`);
                          // if (activity.activityName === 'Implantação') history.push(`/contract/${organizationId}/${contractId}/${activity.activityId}`);
                        }}>
                          <ChevronRight />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </Table>
          </TableContainer>
        </div>
      )}
      {(currentFilters.activityType === 'TODOS' || currentFilters.activityType === 'SIMULATE') && (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ backgroundColor: '#EDEDED', borderRadius: '100px', width: 'fit-content', padding: '6px 9px 6px 9px' }}>
            <span style={{ fontSize: '13px', fontWeight: '400' }}>Simulação</span> 
          </div>
          <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
            <Table>
              <TableRow style={{ height: '70px'}}>
                <TableCell style={{ width: '600px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Nome
                  </span>
                </TableCell>
                <TableCell style={{ width: '1000px' }}>
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                    Status
                  </span>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
                {handleFilters(data.activitiesSimulation).map(activity => (
                  <TableRow key={activity.id} style={{ height: '70px'}}>
                    <TableCell>{activity.name}</TableCell>
                    <TableCell>
                      <div style={{ color: '#191C1A', backgroundColor: '#191C1A14', opacity: '0.8', padding: '0.25rem 0.75rem', borderRadius: '0.75rem', fontWeight: '400', fontSize: '12px', lineHeight: '16px', width: 'fit-content', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                        <span>Aguardando</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      {!shouldNotRedirect.includes(activity.name) && (
                        <IconButton size="small" style={{ cursor: 'pointer' }} onClick={() => {
                          // if (activity.activityName === 'Movimentação') history.push(`/contract/movimentacao/${organizationId}/${contractId}/${activity.activityId}`);
                          // if (activity.activityName === 'Implantação') history.push(`/contract/${organizationId}/${contractId}/${activity.activityId}`);
                        }}>
                          <ChevronRight />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </Table>
          </TableContainer>
        </div>
      )}
    </>
  );
}
